import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  Button,
  Dialog,
  DialogContent,
  Grid as MuiGrid,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons"; // Import specific icons
import * as solidIcons from "@fortawesome/free-solid-svg-icons"; // Import all solid icons
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../../config/firebase";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import AddForm from "./inc/AddForm";
import List from "./inc/List";
import ModalDialogTitle from "../../common/ModalDialogTitle";

const icons = Object.keys(solidIcons)
  .filter((key) => key.startsWith("fa") && key !== "fas" && key !== "prefix")
  .reduce((obj, key) => {
    obj[key] = solidIcons[key];
    return obj;
  }, {});

const CcpAdminResources = ({ pageName, icon }) => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [iconDialogOpen, setIconDialogOpen] = useState(false);

  const fetchResources = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "resources"));
      const resourcesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      resourcesData.sort((a, b) => a.title.localeCompare(b.title));
      setResources(resourcesData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching resources:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResources();
  }, []);

  const handleResourceAdded = () => {
    fetchResources();
  };

  const handleAddDialogOpen = () => {
    setAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setAddDialogOpen(false);
  };

  const handleIconDialogOpen = () => {
    setIconDialogOpen(true);
  };

  const handleIconDialogClose = () => {
    setIconDialogOpen(false);
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddDialogOpen}
            >
              Add New Resource
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleIconDialogOpen}
              sx={{ ml: 2 }}
            >
              Icon Library
            </Button>
            <AddForm
              open={addDialogOpen}
              handleClose={handleAddDialogClose}
              onResourceAdded={handleResourceAdded}
            />
          </Grid>
          <Grid item xs={12}>
            <List
              resources={resources}
              loading={loading}
              fetchResources={fetchResources}
            />
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={iconDialogOpen}
        onClose={handleIconDialogClose}
        maxWidth="lg"
        fullWidth
      >
        <ModalDialogTitle onClose={handleIconDialogClose}>
          Font Awesome Icons
        </ModalDialogTitle>
        <DialogContent>
          <MuiGrid container spacing={2}>
            {Object.keys(icons).map((iconName) => (
              <MuiGrid
                item
                xs={2}
                key={iconName}
                style={{ textAlign: "center" }}
              >
                <FontAwesomeIcon icon={icons[iconName]} size="2x" />
                <div>{iconName}</div>
              </MuiGrid>
            ))}
          </MuiGrid>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default CcpAdminResources;
